import { useEffect, useState } from "react";

const imageChecker = (imageUrl) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true);
    img.onerror = () => resolve(false);
    img.src = imageUrl;
  });
};

const IfscCodeMapper = ({ ifscCode }) => {
  const DEFAULT_IMG = "https://q2pay.in/new_assets/bank_logos/bank_default.svg";
  const [imgSrc, setImgSrc] = useState(DEFAULT_IMG);

  useEffect(() => {
    const loadImage = async () => {
      if (!ifscCode || ifscCode.length < 4) {
        setImgSrc(DEFAULT_IMG);
        return;
      }

      const bankPrefix = ifscCode.substring(0, 4).toLowerCase();
      const imageUrl = `https://q2pay.in/new_assets/bank_logos/${bankPrefix}.svg`;

      const exists = await imageChecker(imageUrl);

      setImgSrc(exists ? imageUrl : DEFAULT_IMG);
    };

    loadImage();
  }, [ifscCode]);

  return (
    <img
      src={imgSrc}
      alt="bank-logo"
    />
  );
};

export default IfscCodeMapper;
